import { c as _c } from "react/compiler-runtime";
import { createFeatureAnalytic } from '@shared/actions';
import { useUser } from '@shared/hooks/useUser';
export function useAnalytics() {
  const $ = _c(2);
  const {
    id
  } = useUser();
  let t0;
  if ($[0] !== id) {
    const addAnalytics = (featureName, sheetId) => id ? createFeatureAnalytic(featureName, id, sheetId) : null;
    t0 = {
      addAnalytics
    };
    $[0] = id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}